import { render } from "./ConfigurationChatDialog.vue?vue&type=template&id=d51b60fc&scoped=true&ts=true"
import script from "./ConfigurationChatDialog.vue?vue&type=script&lang=ts"
export * from "./ConfigurationChatDialog.vue?vue&type=script&lang=ts"

import "./ConfigurationChatDialog.vue?vue&type=style&index=0&id=d51b60fc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d51b60fc"]])

export default __exports__